import React from "react";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

function Resume() {
  return (
    <>
      <div className="mainResumeDiv container pb-4">
        <h3 className="resumeHeading pt-5 pb-3 text-center ">RESUME</h3>

        <div className="container ">
          <div className=" resumeContent mx-auto">
            <div>
              <div className="row my-4">
                <h4 className="ml-auto">Download Resume {"   "}</h4>
                <div className="ml-4 mr-auto">
                  <a
                    href="https://drive.google.com/file/d/1pqSPA6aqsiY9O5H4tcVqgPegM1ZEYEU1/view"
                    download
                  >
                    <CloudDownloadIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Resume;
